import React from 'react';
import UserDetailR from './userDetails';

function IndexUserDetails() {
  return <UserDetailR />;
}

export default IndexUserDetails;
